import React from 'react';
import { connect } from 'react-redux';
import config from "config"
import UserList from "./userlist"
import Modal from "components/common/modal";
import InviteModalContent from "./inviteModalContent"
import EditModalContent from "./editModalContent"
import NodeDropdown from "components/common/dropdowncomponents/nodedropdown"
import ListDropdown from "components/common/dropdowncomponents/listdropdown"
import MainMenu from 'components/common/mainmenu';
import StickyMenu from "components/common/stickymenu"
import StatsMenu from "components/common/statsmenu"
import {
	listContact,
	needContact,
	selectUser,
	resetInviteStatus,
	useradSelectNode,
	useradSelectType
} from "actions/user"

class User extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			AAOpen: false, // add account modal open ?
			AArespond: "",
			AArespondClass: "",
			DAOpen: false, // delete account modal open ?
			DArespond: "",
			DArespondClass: "",
			EAOpen: false, // edit account modal open ?
			EArespond: "",
			EArespondClass: "",

			interval: {}
		};
	}

	componentWillMount() {
		this.props.dispatch(listContact());
		var itv = setInterval(this.props.dispatch, 3000, listContact());
		this.setState({ interval: itv });
	}

	componentWillUnmount() {
		clearInterval(this.state.interval);
	}


	AAOpen() {
		this.props.dispatch(resetInviteStatus());
		this.openInviteModal.open()
		this.setState({ AAOpen: true });
	}

	AAClose() {
		this.props.dispatch(resetInviteStatus());
		this.setState({ AAOpen: false });
	}

	DAOpen() {
		this.setState({ DAOpen: true });
	}

	DAClose() {
		this.props.dispatch(selectUser({}));
		this.setState({ DAOpen: false });
	}
	EAOpen() {
		this.setState({ EAOpen: true });
		this.openEditModal.open();
	}

	EAClose() {
		this.props.dispatch(selectUser({}));
		this.setState({ EAOpen: false });
	}

	componentWillReceiveProps(nextProps) {
		// Init nodeFilter
		if (this.props.nodeFilter.id == -2 && nextProps.tree.id != -2) {
			this.props.dispatch(useradSelectNode(nextProps.tree));
		}
		// Inviting stages
		switch (nextProps.AAstage) {
			case "inviting":
				this.setState({
					AArespond: "Sending...",
					AArespondClass: "text-loading"
				})
				if (nextProps.contactFetched) {
					nextProps.dispatch(needContact());
				}
				break;
			case "invited":
				if (!nextProps.contactFetched) {
					nextProps.dispatch(listContact());
				}
				this.setState({
					AArespond: "Invitation email sent.",
					AArespondClass: "text-green"
				});
				break;
			case "invite-failed":
				this.setState({
					AArespond: "Provided information is invalid.",
					AArespondClass: "text-red"
				})
				break;
			default: // "nothing"
				this.setState({
					AArespond: "",
					AArespondClass: ""
				});
				break;
		}
		// Editing stages
		switch (nextProps.EAstage) {
			case "editing":
				this.setState({
					EArespond: "Editing...",
					EArespondClass: "text-loading"
				})
				if (nextProps.contactFetched) {
					nextProps.dispatch(needContact());
				}
				break;
			case "edited":
				this.setState({
					EArespond: "User edited.",
					EArespondClass: "text-green"
				});
				if (!nextProps.contactFetched) {
					nextProps.dispatch(listContact());
				}
				break;
			case "edit-failed":
				this.setState({
					EArespond: "Failed to edit this user !",
					EArespondClass: "text-red"
				})
				break;
			default: // "nothing"
				this.setState({
					EArespond: "",
					EArespondClass: ""
				});
		}
		// Deleting stages
		switch (nextProps.DAstage) {
			case "deleting":
				if (nextProps.contactFetched) {
					nextProps.dispatch(needContact());
				}
				break;
			case "deleted":
				if (!nextProps.contactFetched) {
					nextProps.dispatch(listContact());
				}
				this.DAClose();
				break;
			default: // nothing
		}
	}

	listNodes(root, depth, res) {
		var self = this;
		if (root && root.type != "sensor") {
			res.push({
				node: root,
				padding: "\u00a0\u00a0".repeat(depth)
			});
			root.children.forEach((child) => {
				self.listNodes(child, depth + 1, res);
			})
		}
	}

	listNodeFilter(root, res) {
		var self = this;
		if (root) {
			if (root.type != "sensor") {
				res.push(root);
				root.children.forEach((child) => {
					self.listNodeFilter(child, res);
				})
			}
		}
	}


	render() {
		var nodes = [];
		this.listNodes(this.props.nodeMap[this.props.me.rootnodeid], 0, nodes)
		return (
			<div className="user-administration-page overwrite--modal--depth">
				<StickyMenu
					withStickyHeader={false}
				>
					<MainMenu
						overviewIsActive={false}
						comparisonIsActive={false}
						onlyLeftMenu={true}
					/>
					<StatsMenu
						leftItemBold={(this.props.me.role == "ADMIN") ? "User Administration" : "Contact"}
						leftItems={
							<React.Fragment>
								{
									(this.props.me.role == "ADMIN") && [
										<span key="0" className="stats-menu__list-item " >
											<div key="0" className="stats-menu-btn cursor--pointer" onClick={this.AAOpen.bind(this)}>
												<span className="display--flex__flex--center cursor--pointer">
													<span style={{ fontSize: 27, marginRight: 8 }} className="font-icon icon-addicon" />
													Add Account
												</span>
											</div>
										</span>
										,
										<span key="1" className="stats-menu__select stats-menu__list-item " >
											<NodeDropdown
												key="1"
												outsideClass="dropdown-btn settings-dropdown pull-left"
												root={this.props.tree}
												nodeFilter={this.props.nodeFilter}
												click={
													(node) => { this.props.dispatch(useradSelectNode(node)) }
												}
												list={this.listNodeFilter.bind(this)}
												header="All locations"
											/>
										</span>,
										<span key="2" className="stats-menu__select stats-menu__list-item " >
											<ListDropdown
												key="2"
												outsideClass="dropdown-btn settings-dropdown pull-left"
												items={config.userTypeFilter}
												getText={(x) => x.text}
												selected={this.props.userTypeFilter}
												click={(code) => { this.props.dispatch(useradSelectType(code)) }}
											/>
										</span>
									]

								}
							</React.Fragment>
						}
					/>
				</StickyMenu>
				<div className="page-content page-content_padding-modifier">
					<div className="display--flex__flex--start--center ">
						<UserList
							contact={this.props.contact}
							openEditModal={this.EAOpen.bind(this)}
							nodeFilter={this.props.nodeFilter}
							userTypeFilter={this.props.userTypeFilter}
							tree={this.props.tree}
						/>
						<Modal
							onClose={this.AAClose.bind(this)}
							ref={(elem) => { this.openInviteModal = elem }}
							clickButton={() => { this.invite.sendInvitation() }}
							header="Add Account"
							buttonText="Send Invitation"
							buttonClass="btn-success"
						>
							<InviteModalContent
								open={this.state.AAOpen}
								onRef={ref => (this.invite = ref)}
								nodes={nodes}
								respond={this.state.AArespond}
								respondClass={this.state.AArespondClass}
							/>
						</Modal>

						<Modal
							onClose={this.EAClose.bind(this)}
							ref={(elem) => { this.openEditModal = elem }}
							clickButton={() => { this.edit.editUser() }}
							header="Edit Account"
							buttonText="Save"
							buttonClass="btn-success"
						>
							<EditModalContent
								onRef={ref => (this.edit = ref)}
								onOpen={this.state.EAOpen}
								user={this.props.selectedUser}
								contact={this.props.contact}
								nodes={nodes}
								respond={this.state.EArespond}
								respondClass={this.state.EArespondClass}
							/>
						</Modal>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		tree: state.overviewReducer.customerOverview,
		nodeMap: state.overviewReducer.nodeMap,
		me: state.myAccountReducer.user,

		AAstage: state.userInviteReducer.stage,
		AArespond: state.userInviteReducer.respond,

		EAstage: state.userAdminReducer.EAstage,
		EArespond: state.userAdminReducer.EArespond,

		selectedUser: state.userAdminReducer.selectedUser,
		contact: state.userAdminReducer.contact,
		contactFetched: state.userAdminReducer.contactFetched,
		nodeFilter: state.userAdminReducer.nodeFilter,
		userTypeFilter: state.userAdminReducer.userTypeFilter
	};
}

function mapDispatchToProps(dispatch) {
	return {
		dispatch
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(User);



// WEBPACK FOOTER //
// ./src/components/pages/user/index.jsx